export let APP_ENV = process.env.REACT_APP_ENV;
export const __DEBUG__ = APP_ENV !== 'production';
export const SENTRY_DSN: string = 'https://a5819edc577f4b9aa31d4f4795982de7@sentry.uncinc.nl/80';

export const IS_SERVER = !(
  typeof window !== 'undefined'
  && window.document
  && window.document.createElement
);
export const IS_CLIENT = !IS_SERVER;

export const DEFAULT_LANGUAGE = process.env.REACT_APP_DEFAULT_LANGUAGE || 'nl';

export const HVC_API_SKIP_AUTH = process.env.REACT_APP_API_SKIP_AUTH || 'ComputerSaysNo';
export let API_URL_OPTIONS = {};
export let API_URL = process.env.REACT_APP_API_URL || '//hvc-bff-api.devinc.eu/api';
export let AUTH_URL = process.env.REACT_APP_AUTH_URL || '//hvc-bff-api.devinc.eu/user/login';

export let LOG_OUT_URL = '//hvc-bff-api.devinc.eu/api/v1/user/logout';

switch (window.document.location.host) {
  case 'staging.mijn.hvcenergie.nl':
    API_URL = 'https://staging.api.mijn.hvcenergie.nl/api'
    AUTH_URL = 'https://staging.api.mijn.hvcenergie.nl/user/login'
    LOG_OUT_URL = 'https://staging.api.mijn.hvcenergie.nl/api/v1/user/logout'
    break;
  case 'accept.mijn.hvcenergie.nl':
    API_URL = 'https://accept.api.mijn.hvcenergie.nl/api'
    AUTH_URL = 'https://accept.api.mijn.hvcenergie.nl/user/login'
    LOG_OUT_URL = 'https://accept.api.mijn.hvcenergie.nl/api/v1/user/logout'
    break
  case 'mijn.hvcenergie.nl':
  case 'prod.mijn.hvcenergie.nl':
    API_URL = 'https://api.mijn.hvcenergie.nl/api'
    AUTH_URL = 'https://api.mijn.hvcenergie.nl/user/login'
    LOG_OUT_URL = 'https://api.mijn.hvcenergie.nl/api/v1/user/logout'
  default: {
    API_URL = API_URL
    AUTH_URL = AUTH_URL
    LOG_OUT_URL = LOG_OUT_URL
  }
}

export let WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL || 'https://www.hvcgroep.nl' as string;

export let LOG_IN_PAGE_MESSAGE: string | null;

export const DISABLE_AUTH = false;

export function saveConstants(options: AppOptions) {
  if (options.env) {
    APP_ENV = options.env;
  }

  if (APP_ENV === 'development') {
    // Use proxy in dev to prevent CORS issues.
    // API_URL = 'http://localhost:3000/api';
    WEBSITE_URL = 'http://localhost:3000/web';
  }

  if (APP_ENV === 'ci') {
    // Use proxy in ci to prevent CORS issues.
    // API_URL = 'http://apache.docker/api';
    WEBSITE_URL = 'http://apache.docker/web';
  }

  if (APP_ENV !== 'production') {
    // Skip auth header for skipping basic auth.
    API_URL_OPTIONS = {
      headers: {
        'X-UncInc-SkipAuth': HVC_API_SKIP_AUTH,
      },
    };
  }

  if (options.logInPageMessage) {
    LOG_IN_PAGE_MESSAGE = options.logInPageMessage;
  }
}

export const PORTAL_ID_LOCALSTORAGE_TOKEN = 'PORTAL_ID_LOCALSTORAGE_TOKEN';

// The value is where the breakpoint starts (mobile-first).
export const SCREEN_MOBILE = 576;
export const SCREEN_TABLET = 768;
export const SCREEN_NORMAL = 992;
export const SCREEN_WIDE = 1240;

export const QUERY_TIMEOUT_TIME = 300;

export const DAYS_BEFORE_ANNUAL_COLLECTION_DATE_THRESHOLD = 45;

export const MAX_BUDGET_BILL_AMOUNT = 2;

export const FAQ_CATEGORIES = {
  WARMTE: '30',
  METERSTANDEN: '29',
};
